import Badge from '../../../../../components/Badge/Badge';

type NumberOfBoatsBadgeProps = {
    numberOfBoats: number;
    editMode?: boolean;
};

const NumberOfBoatsBadge = ({
    numberOfBoats,
    editMode = false,
}: NumberOfBoatsBadgeProps) => {
    if (editMode) {
        return <Badge variant="transparent-white">{numberOfBoats} ▾</Badge>;
    }

    if (numberOfBoats > 1) {
        return <Badge>{numberOfBoats}</Badge>;
    }

    return null;
};

export default NumberOfBoatsBadge;
